import React, { useState } from 'react';
import { TouchableOpacity, View } from 'react-native';
import { Image } from 'expo-image';
import { useSelector } from 'react-redux';

import tw from '../../../../styles/tailwind';
import Text from '../../../../components/Text';
import { Icon } from '../../../../components/Icon';
import IcomoonIcon from '../../../../components/IcomoonIcon';
import useActiveResidentCommunity from '../../../../hooks/useActiveResidentCommunity';


// Selector de vivienda (cuando el residente pertenece a más de una).
function CommunitiesDropdown({ communities, selectedUnit, onCommunitySelected }) {
  const [showList, setShowList] = useState(false);

  return (
    <>
      <TouchableOpacity style={tw`bg-white/10 rounded-xl row`} onPress={() => setShowList(!showList)}>
        <View style={tw`row flex-1 px-4 py-3`}>
          <Icon name="casa" size={20} />
          <Text style={tw`text-white ml-3 flex-1 text-lg font-500`}>{selectedUnit ? selectedUnit.name : "Cargando..."}</Text>
        </View>

        <View style={tw`bg-white/15 h-full rounded-r-xl w-13 items-center`}>
          <View style={tw`flex-1 justify-center`}>
            <IcomoonIcon
              name='chevron-right'
              style={{ transform: [{ rotateZ: '90deg' }], marginRight: 5 }}
              color={tw.color('white')}
              size={14}
            />
          </View>
        </View>
      </TouchableOpacity>

      {
        showList &&
          <View style={tw`bg-white/15 rounded-xl mt-1`}>
            {
              communities.map((community, i) =>
                <TouchableOpacity
                  key={community.uuid}
                  style={tw.style(`px-5 py-3 border-white/10`, i + 1 < communities.length && `border-b`)}
                  onPress={() => {
                    onCommunitySelected(community)
                    setShowList(false)
                  }}
                >
                  <Text style={tw`text-white`}>{community.name}</Text>
                  <Text style={tw`text-white`}>{community.unit.name}</Text>
                </TouchableOpacity>
              )
            }
          </View>
      }
    </>
  )
}


// Header reutilizable: fraccionamiento + dirección de la vivienda (con switch si hay más de una).
export default function CommunityUnitHeader({ community, unit }) {
  const { communities } = useSelector((state: any) => state.status)
  const { setActiveCommunityId } = useActiveResidentCommunity()
  const communitiesCount = communities?.length

  return (
    <View>
      {/* Fraccionamiento */}
      <View style={tw`row mb-3`}>
        <View style={tw`rounded-full mr-3 w-8 h-8 bg-white overflow-hidden`}>
          <Image style={tw`w-full h-full`} source={community?.image_path} />
        </View>

        <Text style={tw`text-white text-lg`}>{community?.name}</Text>
      </View>

      {/* Dirección de la vivienda. Si hay más de una, el botón permite cambiar. */}
      {
        communitiesCount > 1 ?
          <CommunitiesDropdown
            communities={communities}
            selectedUnit={unit}
            onCommunitySelected={c => setActiveCommunityId(c.uuid)}
          />
        :
          <View style={tw`bg-white/10 rounded-xl row px-4 py-3`}>
            <Icon name="casa" size={20} />
            <Text style={tw`text-white ml-3 flex-1 text-lg font-500`}>{unit?.name ?? "Cargando..."}</Text>
          </View>
      }
    </View>
  )
}
